import React from "react";
import ExperienceDetails from "./ExperienceDetails";
import Skills from "./Skills";

function Experience() {
  return (
      <div className="md:flex md:flex-row md:justify-around md:items-center flex flex-col mt-[80px] mb-[80px]">
    <div
     
      className="md:w-[40%] w-full"
    >
      <div className="md:pr-[16px] md:pl-[16px] pr-0 pl-0 space-y-8">
        <h1 className=" text-[2rem] font-extrabold">My Education</h1>
        <div  style={{ borderLeft: "3px solid rgb(245, 223, 78)" }}  className="md:pr-[16px] md:pl-[16px] pr-2 pl-2 space-y-12">
        <ExperienceDetails
          course=" Bachelor in Computer Science "
          universty="Universty of Central Punjab "
          duration=" 2018 - Current"
        />
        <hr className="border-2 border-black"/>
        <ExperienceDetails
          course="Intermidiate Engerning"
          universty="Punjab Group of Colleges "
          duration=" 2016 - 2017"
        />
      </div>
      </div>
      
      </div>
      <div
      
      className="md:w-[40%] w-full"
    >
      <div className="space-y-8 md:mt-0 mt-8">
        <h1 className=" text-[2rem] font-extrabold">My Experience</h1>
        <div style={{ borderLeft: "3px solid rgb(245, 223, 78)" }} className="md:pr-[16px] md:pl-[16px] space-y-12 pr-2 pl-2">
        <ExperienceDetails
          course="React Js Developer "
          universty="Skylinx technologies "
          duration=" 14 Octobar,2021 - Current"
        />
        <hr className="border-2 border-black"/>

        <ExperienceDetails
          course="Front End Developer"
          universty="System Junctions "
          duration=" 14 June, 2021  - 14 August, 2021"
        />
        </div>
      </div>
      
      </div>
    </div>
  );
}

export default Experience;
